import { AimOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, List, Modal, Radio, Select } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { AnnuleerButton } from "~/components/buttons/AnnuleerButton.jsx";
import { AddButton } from "~/components/buttons/AddButton.jsx";
import { $t } from "~/i18n.js";
import { StartIcon } from "~/components/icon/icon.jsx";
import { generate_uuid } from "~/lib/helpers.js";
import { updateFlight } from "~/redux/flights/flights.actions.js";
import { sortClubKisten } from "~/redux/materiaal/materiaal.normalizers.js";
import { message } from "antd";
import { SelectPilot } from "~/components/profile/selectPilot.jsx";

export const SleepClaimModal = ({
  allFlights,
  readOnly,
  activeDay,
  openFlight,
  sleep_kisten,
  vliegers,
  aanmeldingen,
  currentProfile,
}) => {
  const [modalVisible, setShowModal] = useState(false);
  const [pendingSave, setPendingSave] = useState(false);

  const dispatch = useDispatch();

  const [sleepVlieger, setSleepVlieger] = useState(currentProfile || null);
  useEffect(
    () =>
      setSleepVlieger({
        gezagvoerder_id: currentProfile?.id,
        gezagvoerder_naam: currentProfile?.name,
      }),
    [currentProfile],
  );

  const [selectedSleepAircraftId, setSelectedSleepAircraftId] = useState("");
  const [selectedGliderFlightUuid, setSelectedGliderFlightUuid] = useState("");
  const selectedGliderFlight = allFlights.find(
    (flight) => flight.uuid === selectedGliderFlightUuid,
  );
  const selectedSleepAircraft = (sleep_kisten || []).find(
    (kist) => String(kist.id) === selectedSleepAircraftId,
  );
  useEffect(() => {
    setSelectedSleepAircraftId(
      sleep_kisten?.length === 1 ? String(sleep_kisten[0].id) : "",
    );
  }, [sleep_kisten]);

  const aircraftStartMethod = selectedSleepAircraft?.start_methode?.replace(
    "-a",
    "",
  );
  const baseStartMethod = ["tmg", "sep"].includes(aircraftStartMethod)
    ? aircraftStartMethod
    : "tmg";
  const [startMethod, setStartMethod] = useState("tmg");
  useEffect(() => setStartMethod(baseStartMethod), [baseStartMethod]);
  const startMethodOptions = [baseStartMethod, `${baseStartMethod}-a`];

  const addFlight = async () => {
    if (!selectedSleepAircraftId) return;

    setPendingSave(true);

    const new_sleep_uuid = generate_uuid();
    const generateGliderFlight = selectedGliderFlight || startMethod.endsWith("-a")
    
    const gliderUuid = selectedGliderFlight
    ? selectedGliderFlight.uuid
    : (
      generateGliderFlight ? generate_uuid() : null
    );

    const sleepAircraft = {
          kist_id: selectedSleepAircraft?.id,
          registratie: selectedSleepAircraft?.registratie,
          callsign: selectedSleepAircraft?.callsign,
          type: selectedSleepAircraft?.type,
          flarm: selectedSleepAircraft?.flarm,
        }
    const baseData = {
      dag_id: activeDay.dag_id,
      datum: activeDay.datum,
      index: allFlights.length,
      vertrek_vliegveld: activeDay.vertrek_vliegveld,
      aankomst_vliegveld: activeDay.vertrek_vliegveld,
    };

    // first save tow so that it exists in the database
    const sleepFlight = await dispatch(
      updateFlight({
        uuid: new_sleep_uuid,
        sleep_uuid: gliderUuid,
        start_methode: startMethod,
        ...sleepVlieger,
        ...sleepAircraft,
        ...(selectedGliderFlight
          ? {
              dag_id: selectedGliderFlight.dag_id,
              datum: selectedGliderFlight.datum,
              vertrek_vliegveld: selectedGliderFlight.vertrek_vliegveld,
              aankomst_vliegveld: selectedGliderFlight.vertrek_vliegveld,
            }
          : baseData),
      }),
    );

    if (sleepFlight && generateGliderFlight) {
      if (selectedGliderFlight) {
        const gliderFlight = await dispatch(
          updateFlight({
            uuid: selectedGliderFlight.uuid,
            sleep_uuid: new_sleep_uuid,
            start_methode: "sleep",
          }),
        );
        if (!gliderFlight) {
          message.error($t("Er is een fout opgetreden met het opslaan van de zweefvlucht, wijzig in het formulier."));
        }
      } else {
        const gliderFlight = await dispatch(
          updateFlight({
            uuid: gliderUuid,
            sleep_uuid: new_sleep_uuid,
            sleep_uuid_is_new: true,
            start_methode: "sleep",
            ...baseData,
          }),
        );
        if (!gliderFlight) {
          message.error($t("Er is een fout opgetreden met het opslaan van de zweefvlucht, wijzig in het formulier."));
        }
      }
      
    } 
    setPendingSave(false);
    openFlight(sleepFlight);
    onCancel();
    setPendingSave(false);
  };

  const [registratieFilter, setRegistratieFilter] = useState(null);
  let kistenLookup = {};
  let kisten = [];
  const flights = [];

  if (modalVisible) {
    kistenLookup = allFlights.reduce((all, flight) => {
      if (
        ["tmg", "tmg-a", "sep", "sep-a", "sleep"].indexOf(
          flight.start_methode,
        ) < 0 &&
        flight.registratie &&
        !flight.sleep_uuid
      ) {
        all[flight.registratie] = {
          kist_id: flight.kist_id,
          registratie: flight.registratie,
          callsign: flight.callsign,
          type: flight.type,
        };

        if (
          registratieFilter &&
          flight.registratie === registratieFilter
        ) {
          flights.push({
            ...flight,
            sortby: flight.start_tijd ? parseInt(flight.start_tijd.replace(/\D/g, "")) : 0,
          });
        }
      }
      return all;
    }, {});
    kisten = sortClubKisten(
      Object.keys(kistenLookup).map((registratie) => kistenLookup[registratie]),
    );
    flights.sort((a, b) => b.sortby - a.sortby);
  }

  const onCancel = () => {
    setShowModal(false);
    setRegistratieFilter(null);
  };

  return (
    <>
      {modalVisible && (
        <Modal
          title={$t("Voeg sleep toe")}
          open={modalVisible}
          confirmLoading={pendingSave}
          onCancel={onCancel}
          footer={[
            <AddButton
            key="add"
            size='default'
            type='primary'
            disabled={readOnly || !selectedSleepAircraftId}
            loading={pendingSave}
            onClick={addFlight}
            >
              {$t("Voeg vlucht toe")}
            </AddButton>,
            <AnnuleerButton key="annuleren" onClick={onCancel} />,
          ]}
        >
          <div
            className="column"
            style={{
              padding: "0 12px 42px",
              minHeight: 330,
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <p className="small label">{$t("Vlieger")}</p>

            <SelectPilot
              hideAvatar
              readOnly={readOnly}
              field_id="gezagvoerder_id"
              field_name="gezagvoerder_naam"
              title={$t("sleepvlieger")}
              pilot={sleepVlieger}
              otherPilot={null}
              // vliegers gezagvoerder only non-pax
              vliegers={aanmeldingen.filter(
                (aanmelding) => aanmelding.id > 0 && aanmelding.as_sleepvlieger,
              )}
              alle_vliegers={vliegers}
              flight={sleepVlieger}
              saveFlight={(data) => {

                const selectedId = data.gezagvoerder_id;
                if (selectedId === "DELETE") {
                  setSleepVlieger({
                    gezagvoerder_id: null,
                    gezagvoerder_naam: "",
                  });
                  return;
                }

                // regular pilot, set the data
                setSleepVlieger(data);
              }}
              openPilot={null}
              savePayingMember={false}
            />

            <p className="small label" style={{ marginTop: 12 }}>
              {$t("Vliegtuig")}
            </p>

            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              value={selectedSleepAircraftId}
              disabled={readOnly || pendingSave}
              onChange={(event) => {
                setSelectedSleepAircraftId(String(event.target.value));
              }}
              options={[
                ...(sleep_kisten || []).map((kist) => ({
                  value: String(kist.id),
                  label: kist.callsign
                    ? `${kist.callsign} - ${kist.registratie}`
                    : kist.registratie,
                })),
                { value: "other", label: $t("Leeg") },
              ]}
            />

            <p className="small label" style={{ marginTop: 12 }}>
              {$t("Startmethode")}
            </p>

            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              value={startMethod}
              disabled={readOnly || pendingSave}
              onChange={(event) => {
                const method = event.target.value;
                setStartMethod(method);
                if (!method.endsWith("-a")) setSelectedGliderFlightUuid("");
              }}
              options={startMethodOptions.map((method) => ({
                value: method,
                label: $t(method),
              }))}
            />

            {startMethod.endsWith("-a") && (
              <div>
                <p className="small label" style={{ marginTop: 12 }}>
                  {$t("Zweefvliegtuig")}
                </p>
                
                {kisten?.length === 0 && (
                  <p className="small">{$t('Geen losse vluchten beschikbaar om om te zetten, voeg het zweefvliegtuig toe nadat de vlucht is gemaakt.')}</p>
                )}
                {kisten?.length > 0 && (
                  <Select
                    showSearch
                    style={{ width: 200 }}
                    onChange={(registration) => {
                      setRegistratieFilter(registration);
                      setSelectedGliderFlightUuid("");
                    }}
                    filterOption={(input, option) => {
                      const child = option.children
                        ? option.children.toString()
                        : "";
                      return child.toLowerCase().includes(input.toLowerCase());
                    }}
                  >
                    {kisten.map((kist, key) => (
                      <Select.Option key={key} value={kist.registratie}>
                        {`${kist.callsign ? kist.callsign + " - " : ""} ${kist.registratie}`}
                      </Select.Option>
                    ))}
                  </Select>
                )}

                {flights.length > 0 && (
                  <>
                  <p className="small label" style={{ marginTop: 12 }}>
                    {$t("Beschikbare vluchten om om te zetten naar een sleepvlucht (optioneel)")}
                  </p>
                  <Radio.Group
                    value={selectedGliderFlightUuid}
                    onChange={(event) =>
                      setSelectedGliderFlightUuid(event.target.value)
                    }
                    disabled={readOnly || pendingSave}
                    style={{ width: "100%" }}
                  >
                    <List
                      style={{ width: "100%", maxHeight: 230, overflowY: "auto" }}
                      itemLayout="horizontal"
                      dataSource={flights}
                      renderItem={(flight) => (
                        <List.Item
                          onClick={() =>
                            setSelectedGliderFlightUuid(flight.uuid)
                          }
                          style={{ width: "100%", cursor: "pointer" }}
                        >
                          <Radio value={flight.uuid} style={{ width: "100%" }}>
                            <div className="row" style={{ width: "100%" }}>
                              <p style={{ width: 80 }}>
                                <StartIcon color="lightgray" />{" "}
                                {flight.start_tijd || ""}
                              </p>
                              <p style={{ width: 80 }}>
                                {$t(flight.start_methode)}
                              </p>
                              <p>{flight.gezagvoerder_naam || $t("onbekend")}</p>
                            </div>
                          </Radio>
                        </List.Item>
                      )}
                    />
                  </Radio.Group>
                  </>
                )}

                {selectedGliderFlightUuid && flights.length > 0 && (
                  <Button
                    type="text"
                    size="small"
                    icon={<CloseOutlined />}
                    disabled={readOnly || pendingSave}
                    onClick={() => setSelectedGliderFlightUuid("")}
                  >
                    {$t("Deselecteer vlucht")}
                  </Button>
                )}
              </div>
            )}
          </div>
        </Modal>
      )}

      <Button
        size="small"
        icon={<AimOutlined />}
        style={{ marginLeft: 6 }}
        onClick={() => setShowModal(true)}
      >
        {$t("Voeg toe")}
      </Button>
    </>
  );
};
